/**
 * Route IDs and paths as constants for programmatic navigation
 */

export enum Routes {
    // Root level
    THEMES = 'themes',
    COLORS = 'colors',
    FONTS = 'fonts',
    IMAGE_FRAMES = 'image-frames',

    // Colors
    COLORS_CUSTOM_PRESET = 'colors-custom-preset',
    COLORS_PRESET_PREFIX = 'colors-preset-', // Use with color.id

    // Fonts
    FONTS_BEBAS_NEUE = 'fonts-bebas-neue',
    FONTS_SPICY_RICE = 'fonts-spicy-rice',
    FONTS_LORA = 'fonts-lora',
    FONTS_PLAYFAIR_DISPLAY = 'fonts-playfair-display',
    FONTS_FJALLA_ONE = 'fonts-fjalla-one',
    FONTS_BRICOLAGE_GROTESQUE = 'fonts-bricolage-grotesque',

    // Image frames
    IMAGE_FRAMES_ARC = 'image-frames-arc',
    IMAGE_FRAMES_SQUARE = 'image-frames-square',
    IMAGE_FRAMES_ROUNDED_LOW = 'image-frames-rounded-low',
    IMAGE_FRAMES_ROUNDED_MEDIUM = 'image-frames-rounded-medium',
    IMAGE_FRAMES_ROUNDED_STRONG = 'image-frames-rounded-strong',
    IMAGE_FRAMES_FLORAL = 'image-frames-floral',

    // Programmatic routes (AddBlock/EditBlock)
    ADD_BLOCK = 'add-block',
    ADD_BLOCK_TITLE = 'add-block-title',
    ADD_BLOCK_EDITORIAL_TEXT = 'add-block-editorial-text',
    ADD_BLOCK_GALLERY = 'add-block-gallery',
    ADD_BLOCK_TESTIMONIALS = 'add-block-testimonials',
    EDIT_BLOCK_TITLE = 'edit-block-title',
    EDIT_BLOCK_EDITORIAL_TEXT = 'edit-block-editorial-text',
    EDIT_BLOCK_GALLERY = 'edit-block-gallery',
    EDIT_BLOCK_TESTIMONIALS = 'edit-block-testimonials',
    EDIT_BLOCK_HEADER = 'edit-block-header',
    EDIT_BLOCK_PRODUCT_LAYOUT = 'edit-block-product-layout',
}
